import { IAppConfig, WhitelabelPartner } from './IAppConfig';
import { EMAIL_EVENT, ICoveragePackages } from './IPayload';
import { product } from 'c9-tracking';
import { FieldEventDataProps } from '@flos/react-components';

interface ITerms {
    correctInfo: boolean;
    conditions: boolean;
    consent: boolean;
}
export interface IClaimHistory {
    noOfClaims: string | undefined;
    claimHistory: string | undefined;
    terminationTerms: string | undefined;
}

export interface ITextFieldData {
    value: string;
    status: string;
    event: string;
}

export interface IContactInfo {
    name: string;
    addr: string;
    phone: string;
    email: string;
    insuranceAddress: FieldEventDataProps | undefined;
    sameAddress: YES_NO;
}

export interface IQuoteInfo {
    company: string;
    cvrNumber: string;
    name: string;
    phone: string;
    email: string;
    remarks: string;
    condition: EMAIL_EVENT;
}

export interface ICvrData {
    name: string;
    address: string;
    zipcodeAndCity: string;
    cvrNumber: string;
    employees: number;
    employeesStr: string;
    business: {
        key: string;
        name: string;
    };
    businessLine: string;
}

export interface IAccountInfo {
    accNumber: string;
    regNumber: string;
    hasPbsContract: boolean;
}

export interface IError {
    stepOne: boolean;
    stepTwo: boolean;
    separateCallMe: boolean;
}

export interface IInception {
    currently: YES_NO;
    date: string;
}

export interface IAttributes {
    coverages: Array<any>;
    deductibles: Array<any>;
    coverageAmounts: Array<any>;
}

export enum ECoverages {
    Prof = 'Professionelt ansvar',
    Cyber = 'Cyberforsikring',
    GDPR = 'GDPR-dækning',
}

export enum ACoveragesIndex {
    Prof,
    Cyber,
    GDPR,
}

export type ACoverages = [
    { name: ECoverages.Prof; selected: boolean },
    { name: ECoverages.Cyber; selected: boolean },
    { name: ECoverages.GDPR; selected: boolean },
];

export interface B2BProduct {
    monthlyPrice: number;
    chosenCoverages: ACoverages;
    possibleCoverages: ACoverages;
    van?: boolean;
    partnerDiscount?: { percent?: number; amount?: number };
}

export interface IAppProviderState {
    product: B2BProduct;
    claimHistory: IClaimHistory;
    cvrData: ICvrData;
    lockinPeriod: number;
    turnover: number | undefined;
    contactInfo: IContactInfo;
    quote: IQuoteInfo;
    bankInfo: IAccountInfo;
    eCommerceProduct: product;
    emailEvent?: EMAIL_EVENT;
    prevLocation?: any;
    terms: ITerms | null;
    inception: IInception; // the date the insurance go into effect
    salesComplete: boolean;
    hasError: IError;
    initialState: boolean;
    stateChange: boolean;
    isLoading: boolean;
    emailSent: boolean;
    refreshFromCache: boolean;
    flow: FLOW;
    attributes: IAttributes;
    actualStep: number;
    previousStep: number;
    selectedPackage: ICoveragePackages;
    partner: WhitelabelPartner;
    partnerDiscount: { percent: number; amount: number };
    validReceiptRedirection: boolean;
}

export interface IAppProps {
    config: IAppConfig;
    c9log: C9JsLogger;
}

export enum REDUCER_KEY {
    CVR_NUMBER = 'cvr_number',
    CVR_DATA = 'cvr_data',
    EMPLOYEES = 'employees',
    PACKAGE = 'package',
    LOCKINPERIOD = 'lockin_period',
    TURNOVER = 'turnover',
    ADDRESS = 'address',
    CLAIM_HISTORY = 'claim_history',
    COMPLIANCE = 'compliance',
    TELEPHONE = 'telephone',
    CONTACT_INFO = 'contact_info',
    SET_INCEPTION = 'set_inception',
    PAYMENT_SCREEN_ONE = 'payment_screen_one',
    SET_EMAIL_EVENT = 'set_email_event',
    SET_SALES_COMPLETE = 'set_sales_complete',
    SET_STATE_CHANGE = 'set_state_change',
    SET_ERROR = 'set_error',
    SET_INITIAL_STATE = 'set_initial_state',
    RELOAD_STATE = 'reload_state',
    LOADING_DATA = 'loading_data',
    EMAIL_SENT = 'email_sent',
    REFRESH_FROM_CACHE = 'refresh_from_cache',
    RESET_FROM_BACK_BUTTON = 'reset_from_back_button',
    SET_PREV_ROUTE_CONFIG = 'set_prev_route_config',
    SET_ACTUAL_STEP = 'set_actual_step',
    SET_QUOTE_CONDITION = 'set_quote_condition',
    QUOTE_INFO = 'quote_info',
    SET_FLOW = 'set_flow',
    SELECTED_PACKAGE = 'selected_package',
    SET_PARTNER = 'set_partner',
    SET_PARTNER_DISCOUNT = 'set_partner_discount',
    SET_VALID_RECEIPT_REDIRECTION = 'SET_VALID_RECEIPT_REDIRECTION',
}

export enum FLOW {
    BUY = 'buy',
    QUOTE = 'quote',
}

export enum YES_NO {
    NO = 'NO',
    YES = 'YES',
    DONT_KNOW = '',
}
